import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import { Button, Card, CardContent, CardHeader, Stack } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import Grid from "@mui/material/Grid2";
import MaterialBox from "../../components/MaterialBox";
import MaterialInput from "../../components/MaterialInput";
import "./perfomance.css";
import MaterialButton from "../../components/MaterialButton";
import MaterialSelect from "../../components/MasterSelect";
import { useUserDetails } from "../../context/auth";
import request, { gql } from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const employeeId = gql`
  query GetUsersByTeamLeader($teamLeaderId: String!) {
    usersByTeamLeader(teamLeaderId: $teamLeaderId) {
      id

      firstName

      lastName

      department

      designation

      dateJoined

      employeeType

      probationPeriod
    }
  }
`;

const employeeMutation = gql`
  mutation CreatePerformanceEvaluationNew(
    $input: PerformanceEvaluationNewInput!
  ) {
    createPerformanceEvaluation(input: $input) {
      performanceEvaluation {
        id

        user {
          id

          firstName

          lastName
        }

        teamleaderId

        reviewNumber

        duration

        comments

        onTimeWorkDelivery

        professionalBehavior

        assignmentPerformance

        communicationSkills

        teamworkAbility

        multitaskingAbility

        decisionMaking

        attitude

        technicalSkills

        totalScore

        date
      }
    }
  }
`;

const employeeUpdate = gql`
  mutation UpdatePerformanceEvaluation($input: PerformanceEvaluationInput!) {
    updatePerformanceEvaluation(input: $input) {
      performanceEvaluation {
        id

        teamleaderId

        reviewNumber

        duration

        comments

        onTimeWorkDelivery

        professionalBehavior

        assignmentPerformance

        communicationSkills

        teamworkAbility

        multitaskingAbility

        decisionMaking

        attitude

        technicalSkills

        totalScore
      }
    }
  }
`;
const today = new Date().toISOString().split("T")[0];
const PerfomanceEvaluationForm = () => {
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const [peromanceData, setPeromanceData] = useState({
    userId: "",
    date: today,
    teamleaderId: "",
    reviewNumber: "",
    duration: "",
    comments: "",
    onTimeWorkDelivery: "",
    professionalBehavior: "",
    assignmentPerformance: "",
    communicationSkills: "",
    teamworkAbility: "",
    multitaskingAbility: "",
    decisionMaking: "",
    attitude: "",
    technicalSkills: "",
    department: "",
    desgination: "",
    dateofJoing: "",
    dateofJoingStatus: "unchecked",

    userIdStatus: "unchecked",
    dateStatus: "success",
    teamleaderIdStatus: "success",
    reviewNumberStatus: "unchecked",
    durationStatus: "unchecked",
    commentsStatus: "unchecked",
    onTimeWorkDeliveryStatus: "unchecked",
    professionalBehaviorStatus: "unchecked",
    assignmentPerformanceStatus: "unchecked",
    communicationSkillsStatus: "unchecked",
    teamworkAbilityStatus: "unchecked",
    multitaskingAbilityStatus: "unchecked",
    decisionMakingStatus: "unchecked",
    attitudeStatus: "unchecked",
    technicalSkillsStatus: "unchecked",
    departmentStatus: "unchecked",
    desginationStatus: "unchecked",
  });

  const sumarray = [
    peromanceData.onTimeWorkDelivery,
    peromanceData.professionalBehavior,
    peromanceData.assignmentPerformance,
    peromanceData.communicationSkills,
    peromanceData.teamworkAbility,
    peromanceData.multitaskingAbility,
    peromanceData.decisionMaking,
    peromanceData.attitude,
    peromanceData.technicalSkills,
  ];

  useEffect(() => {
    const sum = sumarray?.reduce(
      (acc, cur) => Number(cur?.label || 0) + acc,
      0
    );
    setTotalScore(sum);
  }, [peromanceData]);

  const [employeeData, setEmployeeData] = useState([]);

  const { user } = useUserDetails();
  const location = useLocation();
  const navigate = useNavigate();
  const id = location.state?.id;
  const inputDisbled = location?.state?.disbled;
  const [totalScore, setTotalScore] = useState(0);

  useEffect(() => {
    if (location.state) {
      setPeromanceData({
        userId: {
          value: location.state?.name?.user?.id,
          label:
            location.state?.name?.user?.firstName +
            location.state?.name?.user?.lastName,
        },
        date: location.state?.name?.date,
        teamleaderId: "",
        reviewNumber: location.state?.name?.reviewNumber,
        duration: {
          value: location.state?.name?.duration,
          label: location.state?.name?.duration,
        },
        comments: location.state?.name?.comments,
        onTimeWorkDelivery: {
          value: location.state?.name?.onTimeWorkDelivery?.slice(2),
          label: location.state?.name?.onTimeWorkDelivery?.slice(2),
        },
        professionalBehavior: {
          value: location.state?.name?.professionalBehavior?.slice(2),
          label: location.state?.name?.professionalBehavior?.slice(2),
        },
        assignmentPerformance: {
          value: location.state?.name?.assignmentPerformance?.slice(2),
          label: location.state?.name?.assignmentPerformance?.slice(2),
        },
        communicationSkills: {
          value: location.state?.name?.communicationSkills?.slice(2),
          label: location.state?.name?.communicationSkills?.slice(2),
        },
        teamworkAbility: {
          value: location.state?.name?.teamworkAbility?.slice(2),
          label: location.state?.name?.teamworkAbility?.slice(2),
        },
        multitaskingAbility: {
          value: location.state?.name?.multitaskingAbility?.slice(2),
          label: location.state?.name?.multitaskingAbility?.slice(2),
        },
        decisionMaking: {
          value: location.state?.name?.decisionMaking?.slice(2),
          label: location.state?.name?.decisionMaking?.slice(2),
        },
        attitude: {
          value: location.state?.name?.attitude?.slice(2),
          label: location.state?.name?.attitude?.slice(2),
        },
        technicalSkills: {
          value: location.state?.name?.technicalSkills?.slice(2),
          label: location.state?.name?.technicalSkills?.slice(2),
        },
        department: location.state?.name?.user?.department,
        desgination: location.state?.name?.user?.designation,
        dateofJoing: location.state?.name?.date?.slice(0, 10),
        dateofJoingStatus: "success",

        userIdStatus: "success",
        dateStatus: "success",
        teamleaderIdStatus: "success",
        reviewNumberStatus: "success",
        durationStatus: "success",
        commentsStatus: "success",
        onTimeWorkDeliveryStatus: "success",
        professionalBehaviorStatus: "success",
        assignmentPerformanceStatus: "success",
        communicationSkillsStatus: "success",
        teamworkAbilityStatus: "success",
        multitaskingAbilityStatus: "success",
        decisionMakingStatus: "success",
        attitudeStatus: "success",
        technicalSkillsStatus: "success",
        departmentStatus: "success",
        desginationStatus: "success",
      });
    }
  }, [location.state]);

  const duration = ["15 Days", "1 Month", "6 Month", "1 Year"];

  const points = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];
  const scores = ["0", "1", "2", "3", "4", "5"];

  const contentlabel = [
    "Not applicable",
    "Unsatisfactory",
    "Needs Improvement",
    "Satisfactory",
    "Very Good",
    "Excellent",
  ];

  const handlePermanceChange = (e) => {
    let peromanceDataState = { ...peromanceData };

    const name = e?.target?.name;

    if (name == "comments") {
      const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{2,25})$");
      if (alphaNLenghthRegex.test(e.target.value?.trim())) {
        peromanceDataState[name + "Status"] = "success";
      } else {
        peromanceDataState[name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    } else if (name == "reviewNumber") {
      const alphaNLenghthRegex = new RegExp("^([0-9]{1,25})$");
      if (alphaNLenghthRegex.test(e.target.value?.trim())) {
        peromanceDataState[name + "Status"] = "success";
      } else {
        peromanceDataState[name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    }

    peromanceDataState[name] = e.target.value;
    setPeromanceData({
      ...peromanceData,
      ...peromanceDataState,
    });
  };

  const handleSelectPermanceChange = (event, name) => {
    let peromanceDataState = { ...peromanceData };

    if (name == "userId") {
      const id = event?.value;

      if (id) {
        employeeData?.filter((v) => {
          if (v?.id == id) {
            peromanceDataState["dateofJoing"] = v?.dateJoined?.slice(0, 10);
            peromanceDataState["dateofJoingStatus"] = "success";
            peromanceDataState["department"] = v?.department;
            peromanceDataState["desgination"] = v?.designation;
            peromanceDataState["desginationStatus"] = "success";
            peromanceDataState["departmentStatus"] = "success";
          }
        });
      } else {
        peromanceDataState["dateofJoing"] = "";
        peromanceDataState["dateofJoingStatus"] = "unchecked";
        peromanceDataState["department"] = "";
        peromanceDataState["desgination"] = "";
        peromanceDataState["desginationStatus"] = "unchecked";
        peromanceDataState["departmentStatus"] = "unchecked";
      }

      const lengthRegex = new RegExp("^[A-Za-z0-9]");
      if (lengthRegex.test(event?.label) === true) {
        peromanceDataState[name + "Status"] =
          event?.label === undefined ? "unchecked" : "success";
      } else {
        peromanceDataState[name + "Status"] =
          peromanceDataState.value === "" ? "unchecked" : "error";
      }
    } else if (name == "onTimeWorkDelivery") {
      const lengthRegex = new RegExp("^[A-Za-z0-9]");
      if (lengthRegex.test(event?.label) === true) {
        peromanceDataState[name + "Status"] =
          event?.label === undefined ? "unchecked" : "success";
      } else {
        peromanceDataState[name + "Status"] =
          peromanceDataState.value === "" ? "unchecked" : "error";
      }
    } else if (name == "professionalBehavior") {
      const lengthRegex = new RegExp("^[A-Za-z0-9]");
      if (lengthRegex.test(event?.label) === true) {
        peromanceDataState[name + "Status"] =
          event?.label === undefined ? "unchecked" : "success";
      } else {
        peromanceDataState[name + "Status"] =
          peromanceDataState.value === "" ? "unchecked" : "error";
      }
    } else if (name == "assignmentPerformance") {
      const lengthRegex = new RegExp("^[A-Za-z0-9]");
      if (lengthRegex.test(event?.label) === true) {
        peromanceDataState[name + "Status"] =
          event?.label === undefined ? "unchecked" : "success";
      } else {
        peromanceDataState[name + "Status"] =
          peromanceDataState.value === "" ? "unchecked" : "error";
      }
    } else if (name == "communicationSkills") {
      const lengthRegex = new RegExp("^[A-Za-z0-9]");
      if (lengthRegex.test(event?.label) === true) {
        peromanceDataState[name + "Status"] =
          event?.label === undefined ? "unchecked" : "success";
      } else {
        peromanceDataState[name + "Status"] =
          peromanceDataState.value === "" ? "unchecked" : "error";
      }
    } else if (name == "teamworkAbility") {
      const lengthRegex = new RegExp("^[A-Za-z0-9]");
      if (lengthRegex.test(event?.label) === true) {
        peromanceDataState[name + "Status"] =
          event?.label === undefined ? "unchecked" : "success";
      } else {
        peromanceDataState[name + "Status"] =
          peromanceDataState.value === "" ? "unchecked" : "error";
      }
    } else if (name == "multitaskingAbility") {
      const lengthRegex = new RegExp("^[A-Za-z0-9]");
      if (lengthRegex.test(event?.label) === true) {
        peromanceDataState[name + "Status"] =
          event?.label === undefined ? "unchecked" : "success";
      } else {
        peromanceDataState[name + "Status"] =
          peromanceDataState.value === "" ? "unchecked" : "error";
      }
    } else if (name == "decisionMaking") {
      const lengthRegex = new RegExp("^[A-Za-z0-9]");
      if (lengthRegex.test(event?.label) === true) {
        peromanceDataState[name + "Status"] =
          event?.label === undefined ? "unchecked" : "success";
      } else {
        peromanceDataState[name + "Status"] =
          peromanceDataState.value === "" ? "unchecked" : "error";
      }
    } else if (name == "attitude") {
      const lengthRegex = new RegExp("^[A-Za-z0-9]");
      if (lengthRegex.test(event?.label) === true) {
        peromanceDataState[name + "Status"] =
          event?.label === undefined ? "unchecked" : "success";
      } else {
        peromanceDataState[name + "Status"] =
          peromanceDataState.value === "" ? "unchecked" : "error";
      }
    } else if (name == "technicalSkills") {
      const lengthRegex = new RegExp("^[A-Za-z0-9]");
      if (lengthRegex.test(event?.label) === true) {
        peromanceDataState[name + "Status"] =
          event?.label === undefined ? "unchecked" : "success";
      } else {
        peromanceDataState[name + "Status"] =
          peromanceDataState.value === "" ? "unchecked" : "error";
      }
    } else if (name == "duration") {
      const lengthRegex = new RegExp("^[A-Za-z0-9]");
      if (lengthRegex.test(event?.label) === true) {
        peromanceDataState[name + "Status"] =
          event?.label === undefined ? "unchecked" : "success";
      } else {
        peromanceDataState[name + "Status"] =
          peromanceDataState.value === "" ? "unchecked" : "error";
      }
    }
    peromanceDataState[name] = event;

    setPeromanceData({
      ...peromanceData,
      ...peromanceDataState,
    });
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      peromanceData.userIdStatus === "success" &&
      peromanceData.assignmentPerformanceStatus === "success" &&
      peromanceData.attitudeStatus === "success" &&
      peromanceData.commentsStatus === "success" &&
      peromanceData.communicationSkillsStatus === "success" &&
      peromanceData.decisionMakingStatus === "success" &&
      peromanceData.durationStatus === "success" &&
      peromanceData.multitaskingAbilityStatus === "success" &&
      peromanceData.onTimeWorkDeliveryStatus === "success" &&
      peromanceData.professionalBehaviorStatus === "success" &&
      peromanceData.reviewNumberStatus === "success" &&
      peromanceData.teamleaderIdStatus === "success" &&
      peromanceData.teamworkAbilityStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };
  useEffect(() => {
    request(BASEURL, employeeId, {
      teamLeaderId: user?.teamleader,
    }).then((res) => setEmployeeData(res?.usersByTeamLeader));
  }, []);

  const handleAddPerfomance = async () => {
    const values = {
      userId: peromanceData?.userId?.value,

      teamleaderId: user?.teamleader,

      reviewNumber: peromanceData?.reviewNumber,

      duration: peromanceData?.duration?.label,

      comments: peromanceData?.comments,

      onTimeWorkDelivery: peromanceData?.onTimeWorkDelivery?.label,

      professionalBehavior: peromanceData?.professionalBehavior?.label,

      assignmentPerformance: peromanceData?.assignmentPerformance?.label,

      communicationSkills: peromanceData?.communicationSkills?.label,

      teamworkAbility: peromanceData?.teamworkAbility?.label,

      multitaskingAbility: peromanceData?.multitaskingAbility?.label,

      decisionMaking: peromanceData?.decisionMaking?.label,

      attitude: peromanceData?.attitude?.label,

      technicalSkills: peromanceData?.technicalSkills?.label,
    };
    Swal.fire({
      title: "Are you sure?",
      text: "Sumbit Your Details",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sumbit",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await request(BASEURL, employeeMutation, {
            input: {
              ...values,
            },
          });
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Created Successfully",
            showConfirmButton: false,
            timer: 2500,
          }).then(() => {
            navigate("/performance-evaluation");
          });
        } catch (err) {}
      }
    });
  };

  const handleUpdatePerfomace = async () => {
    const values = {
      id: id,

      teamleaderId: user?.teamleader,

      reviewNumber: peromanceData?.reviewNumber,

      duration: peromanceData?.duration?.label,

      comments: peromanceData?.comments,

      onTimeWorkDelivery: peromanceData?.onTimeWorkDelivery?.label,

      professionalBehavior: peromanceData?.professionalBehavior?.label,

      assignmentPerformance: peromanceData?.assignmentPerformance?.label,

      communicationSkills: peromanceData?.communicationSkills?.label,

      teamworkAbility: peromanceData?.teamworkAbility?.label,

      multitaskingAbility: peromanceData?.multitaskingAbility?.label,

      decisionMaking: peromanceData?.decisionMaking?.label,

      attitude: peromanceData?.attitude?.label,

      technicalSkills: peromanceData?.technicalSkills?.label,
    };

    Swal.fire({
      title: "Are you sure?",
      text: "Update your Details",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Update",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await request(BASEURL, employeeUpdate, {
            input: {
              ...values,
            },
          });
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Updated Successfully",
            showConfirmButton: false,
            timer: 2500,
          }).then(() => {
            navigate("/performance-evaluation");
          });
        } catch (err) {}
      }
    });
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    {location?.state?.status
                      ? "View Perfomance Evaluation"
                      : location?.state?.id
                      ? "Edit Perfomance Evaluation"
                      : "Add Perfomance Evaluation"}
                  </MaterialTypography>
                </Stack>
              </Stack>
            </>
          }
        />
        <CardContent sx={{ minHeight: "90vh" }}>
          <Stack direction="row" spacing={1}>
            <MaterialTypography
              component="label"
              variant="body2"
              fontWeight="bold"
            >
              Evaluation Details
            </MaterialTypography>
          </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Name of the Resource <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="userId"
                  value={peromanceData.userId}
                  defaultValue={{ label: "Please select" }}
                  customStyles={{ optionPadding: 20 }}
                  onChange={(e) => handleSelectPermanceChange(e, "userId")} //selectedValue, event
                  options={employeeData?.map((value) => {
                    return {
                      value: value?.id,
                      label: `${value?.firstName} ${value?.lastName}`,
                    };
                  })}
                  isDisabled={inputDisbled}
                  error={peromanceData.userIdStatus === "error" ? true : false}
                  success={
                    peromanceData.userIdStatus === "success" ? true : false
                  }
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="date"
                  type="date"
                  value={peromanceData.date}
                  placeholder="Enter Employee Name"
                  disabled={true}
                  error={peromanceData.dateStatus === "error" ? true : false}
                  success={
                    peromanceData.dateStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Department <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="userName"
                  value={peromanceData.department}
                  placeholder="Enter Employee Name"
                  disabled={true}
                  error={
                    peromanceData.departmentStatus === "error" ? true : false
                  }
                  success={
                    peromanceData.departmentStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Designation <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="userName"
                  value={peromanceData.desgination}
                  placeholder="Enter Employee Name"
                  disabled={true}
                  error={
                    peromanceData.desginationStatus === "error" ? true : false
                  }
                  success={
                    peromanceData.desginationStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Date of Joining <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="dateofJoing"
                  value={peromanceData.dateofJoing}
                  placeholder="Enter Employee Name"
                  disabled={true}
                  error={
                    peromanceData.dateofJoingStatus === "error" ? true : false
                  }
                  success={
                    peromanceData.dateofJoingStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Evaluated By <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="teamleaderId"
                  placeholder="Enter Employee Name"
                  disabled={true}
                  value={user?.first_name}
                  error={
                    peromanceData.teamleaderIdStatus === "error" ? true : false
                  }
                  success={
                    peromanceData.teamleaderIdStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Review Number <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="reviewNumber"
                  placeholder="Enter Employee Name"
                  value={peromanceData.reviewNumber}
                  onChange={(e) => handlePermanceChange(e)}
                  error={
                    peromanceData.reviewNumberStatus === "error" ? true : false
                  }
                  success={
                    peromanceData.reviewNumberStatus === "success"
                      ? true
                      : false
                  }
                  disabled={inputDisbled}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Duration <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="duration"
                  value={peromanceData.duration}
                  defaultValue={{ label: "Please select" }}
                  customStyles={{ optionPadding: 20 }}
                  onChange={(e) => handleSelectPermanceChange(e, "duration")} //selectedValue, event
                  options={duration.map((value) => {
                    return {
                      value: value,
                      label: value,
                    };
                  })}
                  isClearable
                  error={
                    peromanceData.durationStatus === "error" ? true : false
                  }
                  success={
                    peromanceData.durationStatus === "success" ? true : false
                  }
                  isDisabled={inputDisbled}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Comments <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="comments"
                  placeholder="Enter Your Comments"
                  value={peromanceData.comments}
                  onChange={(e) => handlePermanceChange(e)}
                  error={
                    peromanceData.commentsStatus === "error" ? true : false
                  }
                  success={
                    peromanceData.commentsStatus === "success" ? true : false
                  }
                  disabled={inputDisbled}
                />
              </Grid>
            </Grid>
          </MaterialBox>
          <MaterialBox>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-around",
                alignItems: "center",
                padding: "5px 0px",
                margin: "20px 0px",
              }}
            >
              {contentlabel?.map((v, i) => (
                <p
                  key={i}
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      padding: "3px 8px",
                      margin: "0 5px",
                      borderRadius: "5px",
                      fontWeight: "600",
                      fontSize: "14px",
                      backgroundColor: "#F0F8FF",
                    }}
                  >
                    {i}
                  </span>{" "}
                  <span>{v}</span>
                </p>
              ))}
            </div>
            <div className="tabel-target">
              <table>
                <thead>
                  <tr>
                    <th>Performance Evaluation</th>
                    <th>Scores</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>On time work delivery</td>
                    <td>
                      {" "}
                      <MaterialSelect
                        name="onTimeWorkDelivery"
                        value={peromanceData.onTimeWorkDelivery}
                        defaultValue={{ label: "Please select" }}
                        customStyles={{ optionPadding: 20 }}
                        onChange={(e) =>
                          handleSelectPermanceChange(e, "onTimeWorkDelivery")
                        } //selectedValue, event
                        options={scores.map((value) => {
                          return {
                            value: value,
                            label: value,
                          };
                        })}
                        isDisabled={inputDisbled}
                        error={
                          peromanceData.onTimeWorkDeliveryStatus === "error"
                            ? true
                            : false
                        }
                        success={
                          peromanceData.onTimeWorkDeliveryStatus === "success"
                            ? true
                            : false
                        }
                        isClearable
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Behaved in professional manner</td>
                    <td>
                      {" "}
                      <MaterialSelect
                        name="professionalBehavior"
                        value={peromanceData.professionalBehavior}
                        defaultValue={{ label: "Please select" }}
                        customStyles={{ optionPadding: 20 }}
                        onChange={(e) =>
                          handleSelectPermanceChange(e, "professionalBehavior")
                        }
                        isDisabled={inputDisbled}
                        options={scores.map((value) => {
                          return {
                            value: value,
                            label: value,
                          };
                        })}
                        error={
                          peromanceData.professionalBehaviorStatus === "error"
                            ? true
                            : false
                        }
                        success={
                          peromanceData.professionalBehaviorStatus === "success"
                            ? true
                            : false
                        }
                        isClearable
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Effectively performed assignments</td>
                    <td>
                      {" "}
                      <MaterialSelect
                        name="assignmentPerformance"
                        value={peromanceData.assignmentPerformance}
                        defaultValue={{ label: "Please select" }}
                        customStyles={{ optionPadding: 20 }}
                        onChange={(e) =>
                          handleSelectPermanceChange(e, "assignmentPerformance")
                        }
                        isDisabled={inputDisbled}
                        options={scores.map((value) => {
                          return {
                            value: value,
                            label: value,
                          };
                        })}
                        error={
                          peromanceData.assignmentPerformanceStatus === "error"
                            ? true
                            : false
                        }
                        success={
                          peromanceData.assignmentPerformanceStatus ===
                          "success"
                            ? true
                            : false
                        }
                        isClearable
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Communication skills (Written and oral)</td>
                    <td>
                      {" "}
                      <MaterialSelect
                        name="communicationSkills"
                        value={peromanceData.communicationSkills}
                        defaultValue={{ label: "Please select" }}
                        customStyles={{ optionPadding: 20 }}
                        onChange={(e) =>
                          handleSelectPermanceChange(e, "communicationSkills")
                        }
                        isDisabled={inputDisbled}
                        options={scores.map((value) => {
                          return {
                            value: value,
                            label: value,
                          };
                        })}
                        error={
                          peromanceData.communicationSkillsStatus === "error"
                            ? true
                            : false
                        }
                        success={
                          peromanceData.communicationSkillsStatus === "success"
                            ? true
                            : false
                        }
                        isClearable
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Ability to work with others</td>
                    <td>
                      {" "}
                      <MaterialSelect
                        name="teamworkAbility"
                        value={peromanceData.teamworkAbility}
                        defaultValue={{ label: "Please select" }}
                        customStyles={{ optionPadding: 20 }}
                        onChange={(e) =>
                          handleSelectPermanceChange(e, "teamworkAbility")
                        }
                        options={scores.map((value) => {
                          return {
                            value: value,
                            label: value,
                          };
                        })}
                        isDisabled={inputDisbled}
                        error={
                          peromanceData.teamworkAbilityStatus === "error"
                            ? true
                            : false
                        }
                        success={
                          peromanceData.teamworkAbilityStatus === "success"
                            ? true
                            : false
                        }
                        isClearable
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Ability to handle multiple tasks</td>
                    <td>
                      {" "}
                      <MaterialSelect
                        name="multitaskingAbility"
                        value={peromanceData.multitaskingAbility}
                        defaultValue={{ label: "Please select" }}
                        customStyles={{ optionPadding: 20 }}
                        onChange={(e) =>
                          handleSelectPermanceChange(e, "multitaskingAbility")
                        }
                        options={scores.map((value) => {
                          return {
                            value: value,
                            label: value,
                          };
                        })}
                        isDisabled={inputDisbled}
                        error={
                          peromanceData.multitaskingAbilityStatus === "error"
                            ? true
                            : false
                        }
                        success={
                          peromanceData.multitaskingAbilityStatus === "success"
                            ? true
                            : false
                        }
                        isClearable
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Decision making skills</td>
                    <td>
                      {" "}
                      <MaterialSelect
                        name="decisionMaking"
                        value={peromanceData.decisionMaking}
                        defaultValue={{ label: "Please select" }}
                        customStyles={{ optionPadding: 20 }}
                        onChange={(e) =>
                          handleSelectPermanceChange(e, "decisionMaking")
                        }
                        isDisabled={inputDisbled}
                        options={scores.map((value) => {
                          return {
                            value: value,
                            label: value,
                          };
                        })}
                        error={
                          peromanceData.decisionMakingStatus === "error"
                            ? true
                            : false
                        }
                        success={
                          peromanceData.decisionMakingStatus === "success"
                            ? true
                            : false
                        }
                        isClearable
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Attitude</td>
                    <td>
                      {" "}
                      <MaterialSelect
                        name="attitude"
                        value={peromanceData.attitude}
                        defaultValue={{ label: "Please select" }}
                        customStyles={{ optionPadding: 20 }}
                        onChange={(e) =>
                          handleSelectPermanceChange(e, "attitude")
                        }
                        isDisabled={inputDisbled}
                        options={scores.map((value) => {
                          return {
                            value: value,
                            label: value,
                          };
                        })}
                        error={
                          peromanceData.attitudeStatus === "error"
                            ? true
                            : false
                        }
                        success={
                          peromanceData.attitudeStatus === "success"
                            ? true
                            : false
                        }
                        isClearable
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Technical Skills</td>
                    <td>
                      {" "}
                      <MaterialSelect
                        name="technicalSkills"
                        value={peromanceData.technicalSkills}
                        defaultValue={{ label: "Please select" }}
                        customStyles={{ optionPadding: 20 }}
                        onChange={(e) =>
                          handleSelectPermanceChange(e, "technicalSkills")
                        }
                        isDisabled={inputDisbled}
                        options={scores.map((value) => {
                          return {
                            value: value,
                            label: value,
                          };
                        })}
                        error={
                          peromanceData.technicalSkillsStatus === "error"
                            ? true
                            : false
                        }
                        success={
                          peromanceData.technicalSkillsStatus === "success"
                            ? true
                            : false
                        }
                        isClearable
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        textAlign: "end",
                        padding: "5px 10px",
                        fontWeight: "600",
                      }}
                    >
                      Total Scores
                    </td>
                    <td>{totalScore}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </MaterialBox>
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          {!location?.state?.status && (
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              disabled={!checkAllFields()}
              onClick={
                location.state?.id ? handleUpdatePerfomace : handleAddPerfomance
              }
            >
              {location.state?.id ? "Update" : "Sumbit"}
            </MaterialButton>
          )}

          <MaterialButton
            sx={{ m: 2 }}
            variant="gradient"
            color="dark"
            onClick={() => navigate("/performance-evaluation")}
          >
            Cancel
          </MaterialButton>
        </MaterialBox>
      </Card>
    </DashboardLayout>
  );
};

export default PerfomanceEvaluationForm;
